import styled from 'styled-components';
import { BlackButton } from '@storefront/lib-global/baseComponents/button';
import {
  colours,
  hoverUp,
  media,
  slideFromBottomAnimation,
  spacing,
  zQuickAddToBag,
} from '@storefront/lib-global/stylings';

export const QuickAddToBagContainer = styled.div`
  background-color: ${colours.WHITE};
  bottom: 0;
  left: 0;
  max-height: 80vh;
  overflow-y: auto;
  padding: 20px 26px 36px;
  position: fixed;
  right: 0;
  z-index: ${zQuickAddToBag};
  ${slideFromBottomAnimation}

  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const QuickAddToBagOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${zQuickAddToBag};

  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  padding: 10px;
  ${hoverUp()}

  svg {
    height: 12px;
    width: 12px;
  }
`;

export const AddToBagButton = styled(BlackButton)`
  color: ${colours.WHITE};
  margin: ${spacing.XXS} 0 0 0;
  width: 100%;

  &:disabled {
    cursor: not-allowed;
  }
`;
